import { useState, useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { getAuth, getPremiumPageDiscount, getUIState, getUser, isLoggedIn, isValidDiscount } from "../login/auth_utils";
import { dateString, homeUrl } from "../utils/common_utils";
import { appendJSDependency, getJsonDataPostRequest, removeJSDependency } from "../utils/network_utils";
import IndefiniteProgressBar from "../ui_components/indefinite_progress_bar";
import { firstWeekDaysLeft } from "./payment_utils";
import { BulkSubscriptionOneLine } from "./bulk_subscription";
import {PaymentRegionSelect, CurrencyToggle} from "./payment_regions_select";
import { BigPremiumButton } from "./premium-icon-button-ui";
import {capturePaddleGoogleAdsConversion} from '../google_ads/google_ads_helper'
import { ClockIcon, PercentIcon, ShieldCheckIcon, UserIcon } from "./premium_page_icons";

/**
   * gives UI with generic 70% or 60% discount
   */
function BuyPremium({paymentRegionIndex, setPaymentRegionIndex, discount={}}) {
  const INDIA_PAYMENT_REGION_INDEX = 3;
  const USD_PAYMENT_REGION_INDEX = 0;

  // discountState=1
  const [error, setError] = useState('')
  const [showProgressBar, setShowProgressBar]=useState(false)
  const[paymentUrl, setPaymentUrl]=useState('')
  const [isOutsideIndia, setIsOutsideIndia] = useState(false)
  const[locationLoaded, setLocationLoaded] = useState(false)
  const user=getUser()
  const auth = getAuth()
  const userLoggedIn=isLoggedIn()

  
  
//  const navigate = useNavigate();

 // appendJSDependency(document,  'https://d2xwmjc4uy2hr5.cloudfront.net/im-embed/im-embed.min.js')
  //console.log(user);

  const makePayment = (e) => {
    e.preventDefault();
    setShowProgressBar(true)
    
    let url = homeUrl()+"paymentsApi/createOrGetPaymentRequest";
      getJsonDataPostRequest(url, getAuth(), function(response){
        setShowProgressBar(false);
        if(response==null || response.status>=400){
          setError(response?.message || "Some error occurred, please try again") 
          return    
        }
        setPaymentUrl(response.paymentUrl)
        window.location.href=response.paymentUrl;
        // sample payment url
        // https://www.instamojo.com/@codezym/538686dc727d448a8c30d3cf8eac36ac?embed=form
    })
    
  };

  function initializePaddle(){
    //window.Paddle.Setup({ vendor: '198825'});
    const SANDBOX_TOKEN="test_ca5d9b77b82ea9f246ecafc41a1"
    const PRODUCTION_TOKEN="live_7bc5cd922b7acb35a7a4cb41544"
    window.Paddle.Environment.set('production') //'sandbox' 'production'
    window.Paddle.Initialize({
      token: PRODUCTION_TOKEN, // replace with a client-side token
      eventCallback: function(data) {
        //console.log("Paddle event occured "+JSON.stringify(data))
        if (data.name == "checkout.completed" ||
          data.name=="checkout.loaded"  
          // || data.name=="checkout.closed"
        ) {
          sendPaymentDataToBackend(data,()=>{
            if(data.name=="checkout.completed"){
              // google ads will automatically ignore organic conversions
              capturePaddleGoogleAdsConversion(user.userId, 3000)
              window.location.href='/premium'
              
            }
          })
        }
      }
    });
    console.log("paddle has been initialized with a client side token")
  }

  const makePaddlePayment = (e) => {
    e.preventDefault();
    console.log("inside paddle payment, discount \n "+JSON.stringify(discount))
    // define items
    //const SANDBOX_PRICE_ID="pri_01j5xbsbsxz9zpb3y2z550r43v"
    //const PRODUCTION_PRICE_ID="pri_01j5w7r3t53znqddkj9edzzm1v"
    let itemsList = [
      {
        priceId: discount.paddlePriceId, //PRODUCTION_PRICE_ID,
        quantity: 1
      }
    ];
    // card number is 4242 4242 4242 4242 , rest details as you wish
    window.Paddle.Checkout.open({
      items: itemsList,
      customer: {
        email: user.email,
      },
      customData: {
        userId: ""+user.userId,
        email: user.email,
      },
    });
  };

  function sendPaymentDataToBackend(jsonData, callback) {
    let url = homeUrl()+"paymentsApi/paddle/paddlePaymentFrontendData";
    var data={
      auth:getAuth(),
      json:JSON.stringify(jsonData)
    }
    getJsonDataPostRequest(url, data, function(response){
      callback()
      if(response==null||response.status>=400){
          console.log(response?.message || "Some error occurred, please try again")    
      }
  })
    
  };

  /** fetches and updates user's location country and 
   * whether they are outside india. */
  function fetchUserPaymentCountry() {
  try {
    let url = homeUrl() + "paymentsApi/userPaymentCountry";

    fetch(url)
      .then(response => response.json())
      .then(response => {
        setLocationLoaded(true)
        // in case of error, assume that user is in India
       /* if (response == null || response.status >= 400) {
          return;
        } */

        const outsideIndia = response && response.isOutsideIndia == true;

        setIsOutsideIndia(outsideIndia);
        //setPaymentCountryCode(response.countryCode || "");

        if (outsideIndia) {
          setPaymentRegionIndex(USD_PAYMENT_REGION_INDEX);
        }
      })
      .catch(e => {
        // Backend defaults to India when country is unknown.
        // So frontend should also keep the current/default selection.
        console.log("Unable to fetch payment country", e);
      });
  } catch (e) {
    console.log("Unable to fetch payment country", e);
  }
}

  useEffect(() => {
    fetchUserPaymentCountry()
    const paddleSrc= 'https://cdn.paddle.com/paddle/v2/paddle.js';
    let user=getUser()
    setShowProgressBar(true)
    appendJSDependency(document, paddleSrc, ()=>{
      setShowProgressBar(false)
      console.log("paddle dependency is added")
      initializePaddle()
    })
    
    // Cleanup function
    return () => {
      removeJSDependency(document, paddleSrc);
    };
  }, []); // Empty dependency array ensures this effect runs only once after mount


  return (
    <div className="flex w-full items-center justify-center">
    {
      paymentUrl && paymentUrl.length>5 &&
      <div>
        <a href={paymentUrl} rel="im-checkout" data-behaviour="remote"
         data-style="light" data-text="Checkout With Instamojo"></a>

      </div>
    } 

    { (!paymentUrl || paymentUrl.length<5) &&
    <div className="flex w-full flex-col items-center justify-center px-3 pt-2 sm:px-4">
    <div className="flex w-full items-center justify-center">
    
    {showProgressBar &&
    <div className="mt-8 z-50 flex w-full items-center justify-center">
      <div className="rounded-2xl bg-white px-8 py-6 shadow-sm ring-1 ring-slate-200">
        <IndefiniteProgressBar />
      </div>
    </div> 
    }

    {error && error.length>0 &&
    <div className="mx-auto mt-4 max-w-xl rounded-2xl border border-red-100 bg-red-50 px-5 py-3 text-center text-base font-semibold text-red-700 shadow-sm">
    {error} <br /> 
    </div>
    }
    
     
    </div>

    {
      !userLoggedIn &&
      <div className="
        mb-4 flex w-full max-w-2xl flex-col items-center justify-center
        rounded-2xl border border-blue-100 bg-blue-50/80 px-4 py-3 text-center
        shadow-sm
      ">
        <div className="flex items-center justify-center gap-2 text-base font-bold text-blue-700 sm:text-lg">
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-blue-700 shadow-sm ring-1 ring-blue-100">
           <UserIcon />
          </span>

          <span>Please login if you wish to buy premium.</span>
        </div>
      </div>
    }

     {
      <div className="mb-3 flex w-full flex-row items-center justify-center">
          
        { locationLoaded && !isOutsideIndia &&
          <CurrencyToggle selectedIndex={paymentRegionIndex} 
                setSelectedIndex ={setPaymentRegionIndex}/>
        }   
      
     </div> 
    }

    { // show text below currency select switch

    userLoggedIn && locationLoaded && !isOutsideIndia &&
      <div className="mb-4 flex w-full justify-center px-2">
        { paymentRegionIndex==3 &&
          <div className="
            max-w-2xl rounded-full border border-blue-100 bg-blue-50/70
            px-4 py-2 text-center text-xs font-medium leading-5 text-slate-600
            shadow-sm sm:text-sm
          "> 
           
           {
            <div>Google Pay, PhonePe, other UPI methods also available. We redirect to 
            <span className="font-bold text-slate-800"> Instamojo </span> for payments.
           </div>
           }
          </div>
        }

        { paymentRegionIndex!=3 &&
          <div className="
            max-w-2xl rounded-full border border-blue-100 bg-blue-50/70
            px-4 py-2 text-center text-xs font-medium leading-5 text-slate-600
            shadow-sm sm:text-sm
          "> 
            PayPal, Apple Pay, credit/debit cards and other options available.
          </div>
        }
      </div>
    }


    { userLoggedIn &&
    <div className="mb-5 flex w-full flex-col items-center justify-center text-center">
      <button
        onClick={paymentRegionIndex==3?makePayment:makePaddlePayment}
        className="
          w-full max-w-md rounded-full bg-blue-600
          px-6 py-4 text-lg font-bold text-white shadow-lg shadow-blue-600/20
          transition-all duration-200 hover:-translate-y-0.5 hover:bg-blue-700
          hover:shadow-xl hover:shadow-blue-600/25
          focus:outline-none focus:ring-4 focus:ring-blue-200
          active:translate-y-0 sm:text-xl md:max-w-lg md:text-2xl
        ">
        Buy Premium
      </button> 
    </div>
    }
   
   <GenericDiscount
      discount={discount && isValidDiscount(discount) ? discount : getPremiumPageDiscount()}
      showIndianCurrency={paymentRegionIndex==3}
    />

    <br />
    <br />
    </div>
    }

    </div>
  );
}

/**
 * The UI, image and everything shown in this component
 * will be fetched from backend and stored in local storage
 */
function GenericDiscount({discount=getPremiumPageDiscount(), showIndianCurrency=false}){
  const currency = showIndianCurrency?"Rs": "USD $"
  const BASE_THUMBNAIL_URL="https://public-items-1.s3.ap-south-1.amazonaws.com/codezym/payment_images/"
  const userLoggedIn=isLoggedIn()

  if(!isValidDiscount(discount)) 
    discount = {
    oneLineDescription: "Exclusive First Week Offer, Get Premium at ",
    multiLineDescription: "First Week Offer ,, Get Premium at",
    discountPercentage: 68,
    showOnHomePage: true,
    thumbnailUrl: `${BASE_THUMBNAIL_URL}discount-68-1-sm.jpg`,
    finalAmount: 1600,
    crossedAmount: 5000,
    usdFinalAmount: 42,
    usdCrossedAmount: 132
  }
    //return FiftyOffDiscount()
   // discount.multiLineDescription=discount.multiLineDescription.split(",,")

   // Read the description without changing the original discount object.
  const descriptionLines = Array.isArray(discount.multiLineDescription)
    ? discount.multiLineDescription
    : (discount.multiLineDescription || "").split(",,");

  // Show only the non-empty later-price text for the selected currency.
  const laterPriceValue = showIndianCurrency
    ? discount.priceAfterFirstWeekINR
    : discount.priceAfterFirstWeekUSD;

  const laterPriceText =
    typeof laterPriceValue === "string" ? laterPriceValue.trim() : "";

  return (
     <div className="flex w-full items-center justify-center bg-transparent">
  <div className="w-full max-w-6xl overflow-hidden rounded-3xl bg-white px-4 py-5 shadow-sm ring-1 ring-slate-100 sm:px-6 md:px-8 md:py-7">
    {/* shadow-xl   border border-gray-100* px-2 mt-2 py-2 */}
    <div className="flex flex-col items-center justify-between gap-7 md:flex-row md:gap-8">
      
      {/* Left Text Content */ }
      <div className="w-full md:w-1/2">
        <div className="rounded-3xl bg-white text-center md:text-start">
        {/* p-6 md:p-10 */}
          {/* Offer Badge */}
          <div className="
            inline-flex items-center gap-2 rounded-full
            bg-green-50 px-4 py-2 text-sm font-bold text-green-700
            ring-1 ring-green-100 md:text-base
          ">
            <span className="inline-flex h-6 w-6 items-center justify-center 
            rounded-full bg-green-600 text-white text-xs">
             <PercentIcon className="h-3.5 w-3.5" />
            </span>
            <span>{descriptionLines[0]}</span>
          </div>

          {/* Main Heading */}
          <div className="mt-6 md:mt-8">
            <div className="
              text-3xl font-black leading-tight tracking-tight text-slate-950
              sm:text-4xl md:text-5xl
            ">
              {descriptionLines[1]}
            </div>

            <div className="
              mt-3 text-5xl font-black leading-none tracking-tight text-green-600
              sm:text-6xl md:text-7xl
            ">
              {discount.discountPercentage}% Off
            </div>
          </div>

          {/* Accent Line */}
          <div className="mt-5 flex items-center justify-center gap-3 md:justify-start md:mt-6">
            <div className="h-1 w-14 rounded-full bg-blue-600"></div>
            <div className="h-2 w-2 rounded-full bg-blue-600"></div>
            <div className="h-1 w-12 rounded-full bg-blue-100"></div>
          </div>

          {/* Pricing */}
          <div className="mt-7 flex flex-wrap items-end justify-center gap-4 md:mt-9 md:justify-start md:gap-5">
            <div className="
              text-4xl font-black tracking-tight text-blue-600
              sm:text-5xl
            ">
              {currency} {showIndianCurrency ? discount.finalAmount : discount.usdFinalAmount}
              {showIndianCurrency ? "/-" : ""}
            </div>

            <div className="hidden h-10 w-px bg-gray-200 sm:block"></div>

            <div className="
              pb-1 text-2xl font-bold text-gray-400 line-through
              decoration-red-500 decoration-2 md:text-3xl
            ">
              {currency} {showIndianCurrency ? discount.crossedAmount : discount.usdCrossedAmount}
              {showIndianCurrency ? "/-" : ""}
            </div>
          </div>

  {/* Optional price after the first week, show only after user has logged in 
  and clock has started ticking...
  else people will simply not login thinking they will login when they need to buy */}
    {userLoggedIn && laterPriceText && (
    <div
      className="mt-4 flex items-center gap-3 rounded-2xl bg-amber-50
                px-3 py-2.5 text-left sm:rounded-r-full sm:px-4 sm:py-3">
      <span
        className="
          inline-flex h-10 w-10 shrink-0 items-center justify-center
          rounded-full bg-white/70 text-amber-500
        "
      >
        <ClockIcon />
      </span>

      <span
        className="
          min-w-0 flex-1 break-words text-sm font-medium leading-6
          text-amber-800 [&_strong]:font-extrabold sm:text-base lg:text-lg
        "
        dangerouslySetInnerHTML={{ __html: laterPriceText }}
      />
    </div>
  )}

          {/* Validity */}
          <div className="mt-6 flex items-center justify-center gap-3 font-semibold text-gray-500 md:mt-7 md:justify-start">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-blue-50 text-blue-600">
              <ShieldCheckIcon />
            </span>
            <span>Validity: 365 days</span>
          </div>

        </div>
      </div>

      {/* Right Image */}
      <div className="flex w-full justify-center md:w-1/2 md:justify-end">
        <div className="relative w-full overflow-hidden rounded-[1.75rem] bg-gradient-to-br from-blue-50 via-white to-green-50 p-3 shadow-inner sm:p-4 md:rounded-[2rem] md:p-6">
          <img
            className="h-full w-full rounded-2xl object-cover shadow-lg md:rounded-3xl"
            src={discount.thumbnailUrl}
            alt="Discount Image"
          />

        </div>
      </div>

    </div>
  </div>
</div>
  );
}

export {BuyPremium};